import { computed, Injectable, signal } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class CarritoService {
    private count = signal(0);
    readonly isOpen = computed(() => this.count() > 0);
    readonly enabled = signal(true);

    constructor() { }

    show(): void {
        if (this.enabled()) {
            // Fijamos en 1 para que solo requiera un estado activo
            this.count.set(1);
        }
        const active = document.activeElement as HTMLElement;
        active?.blur();
    }

    hide(): void {
        if (this.enabled()) {
            this.count.set(0);
        }
    }

    reset(): void {
        this.count.set(0);
    }

    disable(): void {
        this.enabled.set(false);
    }

    enable(): void {
        this.enabled.set(true);
    }
}